import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-edit-user-password',
    templateUrl: './edit-user-password.component.html',
    styleUrls: ['./edit-user-password.component.css'],
    standalone: false
})
export class EditUserPasswordComponent implements OnInit {

  form: UntypedFormGroup;
  password = "";

  constructor(private fb: UntypedFormBuilder, private dialogRef: MatDialogRef<EditUserPasswordComponent>) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      password: [this.password, [Validators.required, Validators.minLength(8), Validators.maxLength(255)]],
    });
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      this.dialogRef.close(value);
    }
  }

  close() {
    this.dialogRef.close();
  }

}
